import { api } from "@/lib/api";

import type {
  CreateRawMaterialReq,
  RawMaterial,
  RawMaterialCategory,
  RawMaterialList,
  RawMaterialUsageSummary,
  UpdateRawMaterialReq,
} from "@artisancode/api-types";

export interface RawMaterialListParams {
  page?: number;
  per_page?: number;
  q?: string;
  category?: RawMaterialCategory;
  /** comma-separated RawMaterialKind list, e.g. "purchased,direct" */
  kind?: string;
  ingredient_id?: string;
  is_active?: boolean;
  workspace_id?: string;
}

export const rawMaterialService = {
  list: (params?: RawMaterialListParams) =>
    api.get<RawMaterialList>(
      "/raw-materials",
      params as Record<string, string | number | boolean | undefined>,
    ),

  getById: (id: string) => api.get<RawMaterial>(`/raw-materials/${id}`),

  getUsage: (id: string) =>
    api.get<RawMaterialUsageSummary>(`/raw-materials/${id}/usage`),

  create: (body: CreateRawMaterialReq) =>
    api.post<RawMaterial>("/raw-materials", body),

  update: (id: string, body: UpdateRawMaterialReq) =>
    api.put<RawMaterial>(`/raw-materials/${id}`, body),

  delete: (id: string) => api.del(`/raw-materials/${id}`),
};
